/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import styles from './percentage-button.module.scss';

const PercentageButton = ({ text, onClick, active }) => {
  const dark = useSelector((state) => state.basic.dark);
  return (
    <button
      onClick={() => onClick(text)}
      className={cn(styles.container, { [styles.active]: active, [styles.dark]: dark })}
    >
      <span className={styles.text}>{text}%</span>
    </button>
  );
};

PercentageButton.propTypes = {
  text: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
};

PercentageButton.defaultProps = {
  active: false,
};

export default PercentageButton;
